import { IBase } from './base.interface';
import { IAddress } from './address.interface';
import { IShop } from './shop.interface';

export interface ICustomer extends IBase {
  lastname: string;
  firstname: string;
  email: string;
  password: string;
  token: string;
  phone: string;
  birthday: any;
  optInEmail: boolean;
  optInLoyalty: boolean;
  optInSMS: boolean;
  lastLogin: any;
  registeredFrom: string;
  address?: IAddress;
  addresses: IAddress[];
  shops?: ICustomerShop[];
}

export interface ICustomerShop {
  _id: string | IShop;
  CA: number;
  informations?: string;
  ordersCount: number;
  lastOrderAt?: any;
}
